import { FormattedMessage } from 'react-intl';
import { PoolLink, useIsMobile } from '@synergy/components-next';
import { ReactElement } from 'react';

import { FooterColumn } from './footer-column';
import { FooterColumnItem } from './footer-column-item';
import { FooterColumnTitle } from './footer-column-title';
import { FooterLink } from '../../../models/footer-link';

export const FooterService = ({ links }: { links: FooterLink[] }): ReactElement => {
    const isMobile = useIsMobile();

    return (
        <FooterColumn>
            {isMobile ? undefined : (
                <FooterColumnTitle>
                    <FormattedMessage id="app.footer.service.headline" />
                </FooterColumnTitle>
            )}
            {links.map((link, index) => (
                <FooterColumnItem key={index}>
                    <PoolLink id={link.elementId} colorVariant="grey500" href={link.url}>
                        {link.title}
                    </PoolLink>
                </FooterColumnItem>
            ))}
        </FooterColumn>
    );
};
